import Breadcrumb from "Components/UI/Breadcrumb";
import Spinners from "Components/UI/Spinner";
import PaginatedTable from "Components/Tables/PaginatedTable";
import React, { useEffect, useState } from "react";
import { Card, CardBody, Container } from "reactstrap";
import useTableFilters from "helpers/hooks/useTableFilters";
import { generateQueryParams } from "helpers/queryParams";
import convertDateFormat from "Components/Date/DateFormat";
import { getForms, updateFormStatus } from "helpers/API Calls/System & Settings/Customar Forms";
import ConformationModal from "Components/Modals/ConformationModal";

const head = [
  { id: 0, name: "#", isSortable: true, key: "id" },
  { id: 2, name: "Email", isSortable: true, key: "email" },
  { id: 5, name: "Status", isSortable: true, key: "status" },
  { id: 7, name: "Created", isSortable: true, key: "created_at" },
  { id: 8, name: "Updated", isSortable: true, key: "updated_at" },
  { id: 9, name: "Actions", isSortable: false, key: "actions" }
];

function NewsLetter() {  
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [data, setData] = useState<any[]>([]);
    const [pagination, setPagination] = useState<any>({current_page: 1, last_page: 1, per_page: 10, total: 0});
  
    const [editModal, setEditModal] = useState<boolean>(false);
    const [selectedItem, setSelectedItem] = useState<any>(null);
    
    const { filters, updateFilter } = useTableFilters();
  
    const fetchData = async () => {
      setIsLoading(true);
      const response = await getForms(generateQueryParams(filters) + "&type=newsletter");
      if (response.success) {
        setData(response.data.items);
        setPagination(response.data.pagination);
      }
      setIsLoading(false);
    }
  
    useEffect(() => {
      fetchData();
    }, [filters]);
  
    const handleEditClick = (item) => {
      setSelectedItem(item);
      setEditModal(true);
    };
    
  
    const handleEditConfirm = async () => {
      if (selectedItem) {
        const response = await updateFormStatus(selectedItem.id, {status : selectedItem.status === 1 ? 0 : 1});
        if (response.success) {
          setEditModal(false);
          setSelectedItem(null);
          fetchData();
        }
      }
    };
  
    const onCloseClick = () => {
      setEditModal(false);
      setSelectedItem(null);
    };
  
  return (
    <>
    <div className="page-content">
      <Container fluid>
        <Breadcrumb items={[{ label: 'NewsLetter Subscriptions' }]} />
        {isLoading ? <div className="position-relative vh-100"><Spinners/></div>
        :
        <Card>
          <CardBody>
            <PaginatedTable
              tableHead={head}
              pagination={pagination}
              updateFilter={updateFilter}
              filters={filters}
              > 
              {data.length > 0 && data.map((item) => (                
                <tr key={item.id}>
                  <td>{item.id}</td>
                  <td>{item?.content?.email}</td>
                  <td>
                    <span className={`badge badge-soft-${item.status === 1 ? 'success' : 'danger'}`}>
                      {item.status === 1 ? 'Subscribed' : 'Unsubscribed'}
                    </span>
                  </td>
                  <td>{convertDateFormat(item.created_at)}</td>
                  <td>{convertDateFormat(item.updated_at)}</td>
                  <td>
                    <div>
                      <button className="btn btn-primary btn-sm" onClick={() => handleEditClick(item)}><i className="bx bx-pencil"></i></button>
                    </div>
                  </td>
                </tr>))
              }
              {!isLoading && data.length === 0 && <tr className="text-center"><td colSpan={head.length} className="text-danger">No Data Found</td></tr>}
            </PaginatedTable>
          </CardBody>
        </Card>
        }
      </Container>
    </div>
    {editModal && 
    <ConformationModal
      show={editModal}
      onConfirmClick={handleEditConfirm}
      onCloseClick={onCloseClick}
      textBefore={selectedItem?.status === 1 ? 'unsubscribe' : 'subscribe'}
      message={`"${selectedItem?.content?.email}"`}
      buttonText= {selectedItem?.status === 1 ? 'UnSubscribe' : 'subscribe'}
    />}
    </>
  );
}

export default NewsLetter;
